module.exports = __webpack_public_path__ + "img/zhongguotonghao.f046296d.png";